import { Box } from '@eneco/sparky';
import { styled } from '@eneco/sparky/stitches';
import { BoxProps } from '@eneco/sparky/types';

/**
 * A Box component with a border using the design system's divider color
 */
const StyledBorderedBox = styled(Box, {
  border: '1px solid $borderDividerLowEmphasis',
});

const BorderedBox = (props: BoxProps) => {
  return <StyledBorderedBox backgroundColor="backgroundSecondary" borderRadius="s" padding="6" {...props} />;
};

export default BorderedBox;
